import React, { memo } from 'react'
import { Box, Text } from '@usap/uicomponents'

import ToggleView from '../common/ToggleView'
import SubCats from './ListView.SubCat'

import {
  Container,
  Style,
  SectionHeading,
  Heading,
  End,
} from './ListView.css'

const ListView = ({
  isListView,
  toggleListView,
  selVName,
  categoryPart,
  partList,
  handleCategoryPartsonClick,
  Link,
}) => {
  if (!isListView) return null

  return (
    <>
      <Style />
      <Container
        justify="between"
        align="start"
      >
        <SectionHeading
          id="SectionHeading"
        >
          <Heading
            title="Parts Catalog"
          />
        </SectionHeading>

        <End>
          <ToggleView
            listView={isListView}
            toggleListView={toggleListView}
          />
        </End>
      </Container>

      <Box background="white" margin="medium">
        <ul className="tree">
          <li>
            <input type="checkbox" defaultChecked id="vehicle" />

            <label
              htmlFor="vehicle"
              id="tree_root"
              className="tree_label"
            >
              <Text size="small" color="dark-2">
                {selVName}
              </Text>
            </label>

            {categoryPart.map(
              ({ text, categories }, categoriesPartIndex) => (
                <ul key={text.replace(/ /g, '-')}>
                  <li>
                    <input type="checkbox" id={text.replace(/ /g, '-')} />

                    <label
                      className="tree_label"
                      htmlFor={text.replace(/ /g, '-')}
                    >
                      <Text size="small" color="dark-2">
                        {text}
                      </Text>
                    </label>

                    <SubCats
                      categories={categories}
                      partList={partList}
                      categoriesPartIndex={categoriesPartIndex}
                      handleCategoryPartsonClick={handleCategoryPartsonClick}
                      Link={Link}
                    />
                  </li>
                </ul>
              ),
            )}
          </li>
        </ul>
      </Box>
    </>
  )
}

export default memo(ListView)
